import axios from 'axios';
import { ApiVersionInfo } from '../config/version';
import { getEnv } from '../config/env';

const API_BASE_URL = getEnv('REACT_APP_API_BASE_URL', 'http://localhost:5000');

/**
 * Fetch API version information from the backend
 * This endpoint doesn't require authentication
 */
export async function fetchApiVersion(): Promise<ApiVersionInfo | null> {
  try {
    const response = await axios.get<ApiVersionInfo>(`${API_BASE_URL}/api/version`, {
      timeout: 5000, // 5 second timeout
    });
    return response.data;
  } catch (error) {
    console.warn('Failed to fetch API version:', error);
    return null;
  }
}
